import { MARKETING_PLATFORM } from "src/features/marketing/imports";

export const platformMapping: Record<string, MARKETING_PLATFORM> = {
  IR_CLICK_ID: MARKETING_PLATFORM.IMPACT,
  VOLUUM: MARKETING_PLATFORM.VOLUUM,
  SNAPCHAT: MARKETING_PLATFORM.SNAPCHAT,
  TWITTER: MARKETING_PLATFORM.TWITTER,
  FACEBOOK_CLICK_ID: MARKETING_PLATFORM.FACEBOOK,
  BING_CLICK_ID: MARKETING_PLATFORM.BING,
  GOOGLE_CLICK_ID: MARKETING_PLATFORM.GOOGLE,
  TIKTOK_CLICK_ID: MARKETING_PLATFORM.TIKTOK,
};

export const createPlatformPayload = (
  clickIdObject: Record<string, string>,
  platformMapping: Record<string, MARKETING_PLATFORM>
) =>
  Object.entries(clickIdObject).reduce((payload, [key, clickId]) => {
    const platform = platformMapping[key];
    if (platform && clickId) {
      return { ...payload, [platform]: { clickId } };
    }

    return payload;
  }, {});
